import { render, staticRenderFns } from "./WapTopIntr.vue?vue&type=template&id=bb0aa92c&scoped=true&"
import script from "./WapTopIntr.vue?vue&type=script&lang=js&"
export * from "./WapTopIntr.vue?vue&type=script&lang=js&"
import style0 from "./WapTopIntr.vue?vue&type=style&index=0&id=bb0aa92c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0aa92c",
  null
  
)

export default component.exports